
import { defineComponent, PropType } from "vue";
import { ISiteSearchResultItem } from "../../clients/search/src/models";

export default defineComponent({
  props: {
    result: {
      type: Object as PropType<ISiteSearchResultItem>,
      required: true
    },
    language: {
      type: String,
      required: false,
      default: "",
    }
  },
  computed: {
    resultUrl() {
      const urlParts: string[] = [window.location.origin, this.result?.url];

      return urlParts
        .map(url => (url ? url.replace(/^\/+|\/+$/g, "") : ""))
        .join("/");
    },
    previewTagHeader() {
      if (this.result?.additionalFieldsMultiLingual?.previewTagHeader) {
        return this.result.additionalFieldsMultiLingual.previewTagHeader.split(",")[0];
      }
      return "";
    },
    dateString() {
      if (this.result?.additionalFields?.datestamp) {
        return new Date(this.result.additionalFields.datestamp).toLocaleDateString(this.language, {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
        });
      } else if (this.result?.additionalFields?.displayDate) {
        return this.result?.additionalFields?.displayDate;
      }
    }
  }
});
